export default "__VITE_ASSET__GRE5OrxI__"